export const API_2FA_SETUP = () => `/api/v1/2fa/setup`;
export const API_2FA_CONFIRM = (userId: string) => `/api/v1/2fa/confirm/${userId}`;
export const API_2FA_REMOVE = (userId: string) => `/api/v1/2fa/remove/${userId}`;
export const API_2FA_REMOVE_SELF = () => `/api/v1/2fa/remove-self`;
export const API_2FA_ASK_LATER = (userId: string): string => `/api/v1/2fa/ask-later/${userId}`;
